import { useEffect, useMemo } from 'react'

import { useLazyRef } from '../useLazyRef'

export const useTimers = () => {
	const timersRef = useLazyRef(() => new Map<string, ReturnType<typeof setTimeout>>())

	useEffect(
		() => () => {
			timersRef.current?.forEach((timeout) => {
				clearTimeout(timeout)
			})
			timersRef.current?.clear()
		},
		[timersRef],
	)

	return useMemo(() => {
		const clear = (tag: string) => {
			const timeout = timersRef.current.get(tag)
			if (!timeout) return

			clearTimeout(timeout)
			timersRef.current.delete(tag)
		}

		const set = (tag: string, seconds: number, func: () => void) => {
			clear(tag)
			timersRef.current.set(
				tag,
				setTimeout(() => {
					timersRef.current.delete(tag)
					func()
				}, seconds * 1000),
			)
		}

		return { clear, set }
	}, [timersRef])
}
